import { FileText, Car, User, ShieldCheck, CreditCard } from "lucide-react";
import { API, axios } from "@/utils/constants";

export const STEPS = [
  { key: "type", label: "Tegund", icon: FileText },
  { key: "vehicle", label: "Ökutæki", icon: Car },
  { key: "parties", label: "Aðilar", icon: User },
  { key: "condition", label: "Ástand", icon: ShieldCheck },
  { key: "finance", label: "Fjármál", icon: CreditCard },
];

export const DEAL_TYPES = [
  { value: "selja", label: "Selja", desc: "FONDO selur ökutæki" },
  { value: "kaupa", label: "Kaupa", desc: "FONDO kaupir ökutæki" },
  { value: "thridji", label: "Þriðja aðila", desc: "Sala milli aðila" },
];

export const GREIDSLA_OPTIONS = ["Reiðufé", "Millifærsla", "Debetkort", "Kreditkort", "Annað"];
export const BANK_OPTIONS = [
  "ALÍSA", "Arion banki", "Aur", "Ergo", "FONDO", "Framtíðin", "Íslandsbanki",
  "Landsbankinn", "Lykill fjármögnun", "Netgíró", "Pei", "Rapyd", "Teya", "Annað",
];

export const BREAKDOWN_CATEGORIES = [
  { key: "greidsla", label: "Greiðsla", options: GREIDSLA_OPTIONS },
  { key: "okutaeki", label: "Ökutæki", options: null },
  { key: "fjarmoegnun", label: "Fjármögnun", options: BANK_OPTIONS },
  { key: "vedflutningur", label: "Veðflutningur", options: BANK_OPTIONS },
];

export const EXTRA_PARTY_OPTIONS = [
  { value: "medeigandi", label: "Meðeiganda" },
  { value: "umradamadur", label: "Umráðamann" },
  { value: "fh", label: "Fyrir Hönd Félags (F.H.)" },
  { value: "eu", label: "Eftir Umboð (E.U.)" },
];

export const extraLabel = (type) =>
  type === "medeigandi" ? "Meðeigandi" :
  type === "umradamadur" ? "Umráðamaður" :
  type === "fh" ? "F.H." : "E.U.";

export const lookupPerson = async (kennitala) => {
  try {
    const cache = await axios.get(`${API}/kennitala-cache/${kennitala}`);
    return cache.data;
  } catch {
    const res = await axios.post(`${API}/creditinfo/lookup-person`, { kennitala });
    return res.data;
  }
};
